import React, { useEffect, useState } from 'react';
import { Dialog, DialogContent, Box, Typography, Button, IconButton } from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';
import { AUTH_MODAL_EVENT } from '../utils/authGate';

// Глобальная модалка «Требуется авторизация». Монтируется ОДИН раз в AppShell и
// открывается по window-событию 'openAuthModal' (см. utils/authGate.js). Текст —
// наше стандартное предупреждение; кнопки ведут на /login/ и /register/ и несут
// ?redirect=<текущий URL>, чтобы после входа вернуть пользователя к инструменту.
const AuthModal = () => {
  const [open, setOpen] = useState(false);
  const [redirect, setRedirect] = useState('/ai-photo/');

  useEffect(() => {
    if (typeof window === 'undefined') return undefined;
    const handleOpen = (e) => {
      const target = e?.detail?.redirect;
      if (target) setRedirect(target);
      setOpen(true);
    };
    window.addEventListener(AUTH_MODAL_EVENT, handleOpen);
    return () => window.removeEventListener(AUTH_MODAL_EVENT, handleOpen);
  }, []);

  const go = (base) => {
    if (typeof window === 'undefined') return;
    const enc = encodeURIComponent(redirect || '/ai-photo/');
    window.location.href = `${base}?redirect=${enc}`;
  };

  return (
    <Dialog open={open} onClose={() => setOpen(false)} maxWidth="xs" fullWidth>
      <IconButton
        onClick={() => setOpen(false)}
        sx={{ position: 'absolute', right: 8, top: 8, color: 'text.secondary' }}
        aria-label="Закрыть"
      >
        <CloseIcon />
      </IconButton>
      <DialogContent sx={{ px: 4, py: 5 }}>
        <Box sx={{ textAlign: 'center' }}>
          <Typography variant="h5" gutterBottom sx={{ fontWeight: 700 }}>
            🔐 Требуется авторизация
          </Typography>
          <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
            Войдите в аккаунт, чтобы использовать AI инструменты
          </Typography>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
            <Button
              variant="contained"
              size="large"
              onClick={() => go('/login/')}
              sx={{
                textTransform: 'none',
                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                '&:hover': { background: 'linear-gradient(135deg, #5a6fd8 0%, #6a4190 100%)' },
              }}
            >
              Войти
            </Button>
            <Button
              variant="outlined"
              size="large"
              onClick={() => go('/register/')}
              sx={{ textTransform: 'none', borderColor: '#667eea', color: '#667eea' }}
            >
              Зарегистрироваться
            </Button>
            <Button
              variant="text"
              onClick={() => setOpen(false)}
              sx={{ textTransform: 'none', color: 'text.secondary' }}
            >
              Позже
            </Button>
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default AuthModal;
